const legends = [
    { label: "Much better d>0.80", color: "#4EA72E" },
    { label: "Slightly better d>0.50", color: "#B4E5A2" },
    { label: "Marginally better d>0.20", color: "#D9F2D0" },
    { label: "Not better or worse", color: "#FFC000" },
    { label: "Even worse d<-0.20", color: "#104862" },
];

function CohensDLegends() {
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 20 }}>
            {legends.map(({ label, color }) => (
                <div
                    key={label}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 14,
                    }}
                >
                    <span
                        style={{
                            width: 22,
                            height: 22,
                            backgroundColor: color,
                            border: `2px solid ${color}`,
                            borderRadius: "50%",
                            display: "inline-block",
                            flexShrink: 0,
                        }}
                    />
                    <span>{label}</span>
                </div>
            ))}
        </div>
    );
}

export default CohensDLegends;
